module.exports = __webpack_public_path__ + "img/home-pic-12.e3b2fd92.jpg";